<div class="m-grid__item m-aside-right right-aside-nav-my-class" [hidden]="!visible">
    <ng-template ngFor let-row [ngForOf]="rows">
        <span *ngIf="row.main_title">
            <div class="m-widget2">
                <ng-template ngFor let-content [ngForOf]="row.contents">
                    <div class="m-widget2__item m-widget2__item--{{content.color}} my-{{content.color}}-bg">
                        <div class="m-widget2__checkbox"> </div>
                        <a routerLink="{{content.path}}" class="m-widget2__desc">
                            <span class="m-widget2__text">
                                <h6 title={{content.text}} data-container="body" data-toggle="m-tooltip" [ngClass]="content.color === 'brand'? 'm--font-brand': ''"
                                    attr.data-original-title="{{content.tooltip}}" data-placement="left" style="font-size: 0.9rem;">
                                    <span class="my-{{content.color}}-font">{{content.text}}</span>
                                </h6>
                            </span>
                        </a>
                        <ul class="right-aside-nested-ul" *ngIf="content.children !== undefined">
                            <li *ngFor="let child of content.children" [ngClass]="child.color === 'brand'? 'm--font-brand': 'my-metal-font'">
                                <a title={{child.text}} data-container="body" data-toggle="m-tooltip" 
                                    attr.data-original-title="{{child.tooltip}}" data-placement="left" 
                                    routerLink="{{child.path}}" class="m-widget2__desc">
                                    <h6 class="my-font-nested">{{child.text}}</h6>
                                </a>
                            </li>
                        </ul>
                    </div>
                </ng-template>
            </div>
        </span>
        <span *ngIf="!row.main_title">
            <ng-template ngFor let-content [ngForOf]="row.contents">
                <a routerLink="{{content.path}}">
                    <h6 title={{content.text}} data-container="body" data-toggle="m-tooltip"
                        attr.data-original-title="{{content.tooltip}}" data-placement="left">
                        <span class="my-{{content.color}}-font"><i class="{{content.icon}}"></i> {{content.text}}</span>
                    </h6>
                </a>
            </ng-template>
            <div class="m-separator m-separator--brand m--space-10"></div>
        </span>
    </ng-template>
</div>